export default __webpack_public_path__ + "static/media/PUBLI_1_ORG_16.239c89c2.png";